import { nurseGroupSortKey } from "@utils/common-util";
import { isDispatchedDisplayRow } from "@/components/feature/nurse-membership/splitDispatchedRows";
import type {
  InboundInfo,
  InboundItem,
} from "@/hooks/roster-craete/useRosterSchedule";

export type RowMoveDirection = "up" | "down";

type ReorderRowLike = {
  readonly nurse_id?: string | number;
  readonly id?: string | number;
  readonly role?: string | null;
  readonly active?: unknown;
  readonly is_active?: unknown;
  readonly is_inbound?: boolean;
  readonly inbound?: InboundInfo | readonly InboundItem[] | null;
  readonly assignments?: readonly InboundItem[] | null;
};

function isReorderRowLike(row: unknown): row is ReorderRowLike {
  return typeof row === "object" && row !== null;
}

export function getReorderRowId(row: unknown): string {
  if (!isReorderRowLike(row)) return "";
  return String(row.nurse_id ?? row.id ?? "");
}

export function isRowSequenceBlocked(row: unknown): boolean {
  if (!isReorderRowLike(row)) return true;
  const id = getReorderRowId(row);
  return id.trim() === "" || id.startsWith("temp_") || isDispatchedDisplayRow(row);
}

export function canSwapRows(source: unknown, target: unknown): boolean {
  if (isRowSequenceBlocked(source) || isRowSequenceBlocked(target)) {
    return false;
  }
  if (!isReorderRowLike(source) || !isReorderRowLike(target)) return false;
  return nurseGroupSortKey(source) === nurseGroupSortKey(target);
}
